// Total Value Delivered (TVD) data fetcher.
// Server-side helper called by the TVD Sitecore component during render.

export type TvdMonetaryValue = {
  value: string;
};

export type TvdMonetaryData = {
  business_outcomes: TvdMonetaryValue;
  operational_performance: TvdMonetaryValue;
  environmental_impact: TvdMonetaryValue;
};

export type TvdResponse = {
  Market: string;
  customer: string;
  data: TvdMonetaryData;
};

export async function fetchTvdData(): Promise<TvdResponse> {
  // TVD API integration goes here. Currently returns stub data.
  return {
    Market: "Data Center",
    customer: "Microsoft",
    data: {
      business_outcomes: { value: "$888K" },
      operational_performance: { value: "$2M" },
      environmental_impact: { value: "$158K" },
    },
  };
}
